module.exports = __webpack_public_path__ + "img/transfer-cert-notary.0501cd7f.png";